import appApi from '../../../../../api/app-api';
import { CheckStatusType } from '../../../../../api/types/students/payment-services/user-payments/user-payment-service-with-price-list';
import { toast } from 'react-toastify';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';

export const updateCheckStatusOperation = async (
  paymentId: number,
  checkId: number,
  checkStatus: CheckStatusType,
  bounceReasonId: number | null,
  /** YYYY-MM-DD — required when checkStatus === BOUNCED; null omits the field */
  valueDate: string | null,
  setLoading: (loading: boolean) => any,
) => {
  try {
    setLoading(true);
    const res = await appApi.updateCheckStatus(
      paymentId,
      checkId,
      checkStatus,
      bounceReasonId,
      valueDate,
    );

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }
    setLoading(false);
  } catch (e) {
    setLoading(false);
    throw e;
  }
};
